import React from "react"
import { Link, useLocation } from "react-router-dom"
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined"
import { useSelector } from "react-redux"

const Breadcrumbs = () => {
  const mode = useSelector((state) => state.Layout.layoutMode)
  const location = useLocation()
  const pathname = location.pathname
  let pathParts = pathname.split("/").filter((x) => x)

  // ✅ Keep dashboard when it's part of the route (for navigation)
  // But only remove it when it’s the ONLY segment (like /dashboard)
  if (pathParts.length > 1 && pathParts[0] === "dashboard") {
    // Do not remove dashboard — we’ll handle it for breadcrumb path building
  }

  const lastPart = pathParts[pathParts.length - 1]

  // Special case override
  const specialRoutes = ["office", "integrations", "profile", "history"]
  const isSpecialCase = specialRoutes.includes(lastPart)

  // Custom label mapping
  const customLabels = {
    profile: "Account",
    "organizations-list": "Offices",
    "create-post": "Create Post",
    "create-campaign": "Create Campaign", 
  }

  // Fallback label generator
  const getLabel = (part) => customLabels[part] || part.charAt(0).toUpperCase() + part.slice(1)

  return (
    <nav
      aria-label="breadcrumb"
      style={{
        display: "flex",
        alignItems: "center",
        color: mode === "dark" ? "#fff" : "#05040969",
      }}
    >
      {/* Home icon only */}
      <Link
        to="/"
        style={{
          color: mode === "dark" ? "#fff" : "#05040969",
          display: "flex",
          alignItems: "center",
        }}
      >
        <HomeOutlinedIcon style={{ fontSize: "22px", marginRight: "5px" }} />
      </Link>

      {isSpecialCase ? (
        <>
          <span style={{ margin: "0 8px" }}>/</span>
          <Link to="/admin-consoles" style={{ color: mode === "dark" ? "#fff" : "#05040969" }}>
            Admin Consoles
          </Link>
          <span style={{ margin: "0 8px" }}>/</span>
          <span style={{ color: mode === "dark" ? "#fff" : "#050409" }}>
            {getLabel(lastPart)}
          </span>
        </>
      ) : (
        pathParts.map((part, index) => {
          const routeTo = "/" + pathParts.slice(0, index + 1).join("/")
          const isLast = index === pathParts.length - 1
          const label = getLabel(part)

          return (
            <span key={routeTo} style={{ display: "flex", alignItems: "center" }}>
              <span
                style={{
                  margin: "0 8px",
                  color: mode === "dark" ? "#fff" : "#05040969",
                }}
              >
                /
              </span>

              {isLast ? (
                <span
                  style={{
                    color: mode === "dark" ? "#fff" : "#050409",
                  }}
                >
                  {label}
                </span>
              ) : (
                <Link
                  to={routeTo}
                  style={{
                    color: mode === "dark" ? "#fff" : "#05040969",
                  }}
                >
                  {label}
                </Link>
              )}
            </span>
          )
        })
      )}
    </nav>
  )
}

export default Breadcrumbs
